export default __webpack_public_path__ + "static/media/banner-criatividade.896a9c6a.png";